module.exports = __webpack_public_path__ + "img/cms-logo-magento.3f9de741.png";